import { render, staticRenderFns } from "./BaseFilteredBackground.vue?vue&type=template&id=4380eb04&"
import script from "./BaseFilteredBackground.vue?vue&type=script&lang=js&"
export * from "./BaseFilteredBackground.vue?vue&type=script&lang=js&"
import style0 from "./BaseFilteredBackground.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports